import React, { ReactElement, useState } from 'react';
import { Loader, Text } from 'idsk-react-components';
import {
  LegislativnyMaterialHistoria,
  useLegMaterialHistoria,
} from '../LegislativnyMaterialHistoria';
import Actions from './component/Actions/Actions';
import LegislativnyMaterialBasicData
  from './component/LegislativnyMaterialBasicData/LegislativnyMaterialBasicData';
import LegislativnyMaterialDetailType
  from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import './legislativnyMaterialDetail.scss';
import LegislativnyMaterialNonPublicData
  from './component/LegislativnyMaterialNonPublicData/LegislativnyMaterialNonPublicData';
import LegMaterialPripomienkovanieMessage
  from './component/LegMaterialPripomienkovanieMessage/LegMaterialPripomienkovanieMessage';
import LegMaterialNekonzistentneStadiumMessage
  from './component/LegMaterialNekonzistentneStadiumMessage/LegMaterialNekonzistentneStadiumMessage';
import LegMaterialZapisStanoviskaMessage
  from './component/LegMaterialZapisStanoviskaMessage/LegMaterialZapisStanoviskaMessage';

interface Props {
  materialDetail: LegislativnyMaterialDetailType;
  reloadMaterialDetail(): void;
}

const LegislativnyMaterialDetail = ({
  materialDetail,
  reloadMaterialDetail,
}: Props): ReactElement => {
  const {
    legMaterialHistoriaList,
    legMaterialHistoriaStatus,
    reloadLegMaterialHistoriaList,
  } = useLegMaterialHistoria(materialDetail?.uuid);

  const [publicDataVisible, setPublicDataVisible] = useState<boolean>(true);

  return (
    <div className="material-detail">
      <Text type="p" size="l" className="material-detail__nazov">{materialDetail.nazov}</Text>
      <Actions
        sledovany={materialDetail?.sledovany}
        legMaterial={materialDetail}
        historiaRecords={legMaterialHistoriaList?.historiaRecords}
        updateMaterial={() => {
          reloadMaterialDetail();
          reloadLegMaterialHistoriaList();
        }}
        publicDataVisible={publicDataVisible}
        setPublicDataVisible={setPublicDataVisible}
      />
      <LegMaterialNekonzistentneStadiumMessage
        legMaterial={materialDetail}
        legMaterialHistoriaList={legMaterialHistoriaList}
      />
      <LegMaterialPripomienkovanieMessage legMaterial={materialDetail} />
      <LegMaterialZapisStanoviskaMessage legMaterial={materialDetail} />
      {publicDataVisible
        ? <LegislativnyMaterialBasicData materialDetail={materialDetail} />
        : <LegislativnyMaterialNonPublicData materialDetail={materialDetail} />}
      <Loader loading={legMaterialHistoriaStatus.loading}>
        {legMaterialHistoriaList?.historiaRecords.length > 0 && (
          <LegislativnyMaterialHistoria
            materialDetail={materialDetail}
            legMaterialHistoriaList={legMaterialHistoriaList}
          />
        )}
      </Loader>
    </div>
  );
};

export default LegislativnyMaterialDetail;
